export default __webpack_public_path__ + "static/media/GirlWithHat_img.6a3291b2.jpg";